import React, { useEffect, useState } from "react";
/**
 * @todo Can this be used anywhere else? can it be global?
 */
export interface ITimer {
  initialMinute: number;
  initialSeconds: number;
}
export const Timer = ({ initialMinute = 0, initialSeconds = 0 }: ITimer) => {
  const [minutes, setMinutes] = useState(initialMinute);
  const [seconds, setSeconds] = useState(initialSeconds);

  useEffect(() => {
    const myInterval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(myInterval);
          window.location.reload();
        } else {
          setMinutes(minutes - 1);
          setSeconds(59);
        }
      }
    }, 1000);
    return () => {
      clearInterval(myInterval);
    };
  });

  return (
    <React.Fragment>
      {minutes === 0 && seconds === 0 ? null : (
        <span style={{ color: "inherit" }}>
          {" "}
          {minutes}:{seconds < 10 ? `0${seconds}` : seconds}
        </span>
      )}
    </React.Fragment>
  );
};
